import { stdObject } from "../../../data/types/stdObject";
import { sendData } from "../../../services/sendData";

export const createAutomaticBackup = async (
  bDate: string[],
  params: stdObject,
) => {
  const { logoutAction, closeMsg } = params;
  const responseAutBackup = await sendData({
    endPoint: "createAutomaticBackup",
    payload: { bDate },
    logoutAction,
  });
  console.log("responseAutBackup", responseAutBackup);
  if (closeMsg) {
    closeMsg();
  }
};
